import { connect } from 'react-redux';

import logout from '../../actions/logout';
import NavigationSideMenu from '../../components/navigation/side/Menu';
import { sideMenuCollapsed } from '../../reducers/analyticsApp';
import { setSideMenuCollapsed } from '../../actions/application';

const mapStateToProps = (state) => ({
  menuGroups: {},
  sideMenuCollapsed: sideMenuCollapsed(state),
});

const mapDispatchToProps = {
  onLogout: logout,
  setSideMenuCollapsed,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationSideMenu);
